import React from "react";

const GridRefContext = React.createContext<React.RefObject<HTMLDivElement> | undefined>(undefined);


export default GridRefContext;
